import { render, staticRenderFns } from "./EmployeeDocumentUpload.vue?vue&type=template&id=23d9a35d&"
import script from "./EmployeeDocumentUpload.vue?vue&type=script&lang=js&"
export * from "./EmployeeDocumentUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports